import { render, staticRenderFns } from "./NeiBuFile5.vue?vue&type=template&id=4e08a4f4&scoped=true&"
import script from "./NeiBuFile5.vue?vue&type=script&lang=js&"
export * from "./NeiBuFile5.vue?vue&type=script&lang=js&"
import style0 from "./NeiBuFile5.vue?vue&type=style&index=0&id=4e08a4f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e08a4f4",
  null
  
)

export default component.exports